module.exports = "https://r.nearpod.com/assets/media/image/beta-label-c7b9c2bce018626976c570c3a94bd459.svg";